<template>
  <div>
    <div id="k_chart2"></div>
    <div class="k_time"><span>{{ t1 }}</span><span>{{ t2 }}</span></div>
    <div id="k_chart3"></div>
  </div>
</template>

<script>
import * as echarts from 'echarts'

export default {
  props: {
    stockData: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      t1: '',
      t2: ''
    }
  },
  mounted() {
    this.drawChart()
  },
  watch: {
    stockData: {
      handler() {
        this.drawChart()
      },
      deep: true
    }
  },
  methods: {
    fontSize(res) {
      const docEl = document.documentElement
      const clientWidth = window.innerWidth || docEl.clientWidth || document.body.clientWidth
      if (!clientWidth) return res
      const fontSize = clientWidth / 750
      return res * fontSize
    },
    drawChart() {
  const data = this.stockData
  // 按日期排序（升序）
  const dates = Object.keys(data).sort()
  if (dates.length === 0) return

  this.t1 = dates[0]
  this.t2 = dates[dates.length - 1]

  // 提取数据
  const categoryData = dates
  const values = dates.map(date => {
    const d = data[date]
    return [d.open, d.close, d.low, d.high]
  })
  const ma5 = dates.map(date => data[date].ma_a)
  const ma10 = dates.map(date => data[date].ma_b)
  const ma20 = dates.map(date => data[date].ma_c)
  
  // 成交量数据
  const volumes = dates.map(date => {
    const d = data[date]
    return {
      value: parseFloat(d.volume) || 0,
      isUp: d.close >= d.open
    }
  })

  // 颜色定义
  const upColor = '#FE484A'
  const upBorderColor = '#FE484A'
  const downColor = '#0AC890'
  const downBorderColor = '#0AC890'
  const ma5Color = '#63A0FF'
  const ma10Color = '#FFA500'
  const ma20Color = '#9ACD32'

  // ========== 计算 Y 轴最大最小值 ==========
  var allPrices = []
  values.forEach(function(item) {
    allPrices.push(item[1]) // 收盘价
    allPrices.push(item[2]) // 最低价
    allPrices.push(item[3]) // 最高价
  })
  var yMax = Math.max.apply(null, allPrices)
  var yMin = Math.min.apply(null, allPrices)

  // ========== K线图配置 ==========
  const option1 = {
    grid: {
      left: 10,
      right: 10,
      top: 25,
      bottom: 35,
    },
    xAxis: {
      type: 'category',
      data: categoryData,
      scale: true,
      boundaryGap: false,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      splitNumber: 20,
      min: 'dataMin',
      max: 'dataMax',
      axisLabel: { show: false }
    },
    yAxis: {
      min: yMin,
      max: yMax,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { 
        show: true, 
        lineStyle: { color: '#E8E8E8', type: 'dashed' } 
      },
      position: 'left',
      axisLabel: {
        color: '#939393',
        fontSize: this.fontSize(18),
        //margin: -80,
        inside: true,        // 👈 核心：自动将标签显示在轴线内侧

        formatter: function(value) {
          if (value === yMax || value === yMin) {
            return value.toFixed(2)
          }
          return ''
        }
      }
    },
    series: [
      {
        name: 'K线图',
        type: 'candlestick',
        data: values,
        itemStyle: {
          color: upColor,
          color0: downColor,
          borderColor: upBorderColor,
          borderColor0: downBorderColor
        },
        // markPoint: {
        //   data: [
        //     {
        //       name: '最高价',
        //       type: 'max',
        //       valueIndex: 3,
        //       symbol: 'circle',
        //       symbolSize: 0,
        //       label: {
        //         show: true,
        //         position: 'inside',
        //         color: '#FE484A',
        //         fontSize: this.fontSize(18),
        //         formatter: function(params) {
        //           return params.value.toFixed(2)
        //         }
        //       },
        //       itemStyle: {
        //         color: '#FE484A'
        //       }
        //     },
        //     {
        //       name: '最低价',
        //       type: 'min',
        //       valueIndex: 2,
        //       symbol: 'circle',
        //       symbolSize: 0,
        //       label: {
        //         show: true,
        //         position: 'inside',
        //         color: '#0AC890',
        //         fontSize: this.fontSize(18),
        //         formatter: function(params) {
        //           return params.value.toFixed(2)
        //         }
        //       },
        //       itemStyle: {
        //         color: '#0AC890'
        //       }
        //     }
        //   ]
        // }
      },
      {
        name: 'MA5',
        type: 'line',
        data: ma5,
        smooth: true,
        lineStyle: { opacity: 1, color: ma5Color },
        symbol: 'circle',
        showSymbol: true,
        color: ma5Color,
        symbolSize: 0,
        itemStyle: {
          normal: {},
          emphasis: {
            borderColor: '#fff',
            borderWidth: 2,
            shadowColor: ma5Color,
            shadowBlur: 10
          }
        }
      },
      {
        name: 'MA10',
        type: 'line',
        data: ma10,
        smooth: true,
        lineStyle: { opacity: 1, color: ma10Color },
        symbol: 'circle',
        showSymbol: true,
        color: ma10Color,
        symbolSize: 0,
        itemStyle: {
          normal: {},
          emphasis: {
            borderColor: '#fff',
            borderWidth: 2,
            shadowColor: ma10Color,
            shadowBlur: 10
          }
        }
      },
      {
        name: 'MA20',
        type: 'line',
        data: ma20,
        smooth: true,
        lineStyle: { opacity: 1, color: ma20Color },
        symbol: 'circle',
        showSymbol: true,
        color: ma20Color,
        symbolSize: 0,
        itemStyle: {
          normal: {},
          emphasis: {
            borderColor: '#fff',
            borderWidth: 2,
            shadowColor: ma20Color,
            shadowBlur: 10
          }
        }
      }
    ]
  }

  // ========== 成交量图配置 ==========
  const option2 = {
    grid: {
      left: 5,
      right: 5,
      top: 5,
      bottom: 5
    },
    xAxis: {
      type: 'category',
      data: categoryData,
      scale: true,
      boundaryGap: false,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      axisLabel: {
        color: '#939393',
        fontSize: this.fontSize(18),
        show: false,
        interval: Math.ceil(categoryData.length / 8)
      }
    },
    yAxis: {
      scale: true,
      axisLine: { show: false },
      axisTick: { show: false },
      splitLine: { show: false },
      position: 'left',
      axisLabel: {
        color: '#939393',
        fontSize: this.fontSize(18),
        formatter: function(value) {
          if (value >= 10000) {
            return (value / 10000).toFixed(1) + '万'
          }
          return value
        }
      }
    },
    series: [
      {
        name: '成交量',
        type: 'bar',
        data: volumes.map(function(item) { return item.value }),
        itemStyle: {
          color: function(params) {
            return volumes[params.dataIndex].isUp ? upColor : downColor
          }
        },
        barWidth: '60%',
        barGap: '10%'
      }
    ]
  }

  // ========== 渲染图表 ==========
  const chart1 = echarts.init(document.getElementById('k_chart2'))
  chart1.setOption(option1)

  const chart2 = echarts.init(document.getElementById('k_chart3'))
  chart2.setOption(option2)

  // 窗口自适应
  const resizeHandler = function() {
    chart1.resize()
    chart2.resize()
  }
  window.addEventListener('resize', resizeHandler)
}
  }
}
</script>

<style lang="scss">
.k_time {
    font-size: 0.24rem;
    color: #939393;
    position: relative;
    height:16px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}


</style>